import type {
  complexMatchSpec,
  dealerCodeSpecComplexMatchSpec,
  dealerSearchIncoming
} from "@dealer-center/ddc-pages-account-search-interface";

interface mappingInterface {
  key: keyof dealerSearchIncoming;
  label: string;
}

export const itemIsDateRange = (
  item:
    | complexMatchSpec<string | number>
    | { before: string; after: string }
    | dealerCodeSpecComplexMatchSpec
): item is { before: string; after: string } =>
  (item as { before: string; after: string }).before !== undefined;

export const mapping: mappingInterface[] = [
  { key: "ids", label: "account id" },
  { key: "names", label: "company name" },
  { key: "urls", label: "url" },
  { key: "statuses", label: "status" },
  { key: "accountTypes", label: "account type" },
  { key: "verticalTypes", label: "vertical types" },
  { key: "franchises", label: "franchise" },
  { key: "resources", label: "resource" },
  {
    key: "controlCenterPlatforms",
    label: "controlcenter platform"
  },
  { key: "countries", label: "country" },
  { key: "states", label: "state" },
  { key: "postalCodes", label: "postal code" },
  { key: "created", label: "created date" },
  { key: "dealerCodes", label: "dealer code" }
];
export const itemIsComplexMatchSpecString = (
  item:
    | { before: string; after: string }
    | complexMatchSpec<string | number>
    | dealerCodeSpecComplexMatchSpec
): item is complexMatchSpec<string | number> => {
  return (
    typeof (item as complexMatchSpec<string | number>).matchAny?.[0] ===
      "string" ||
    typeof (item as complexMatchSpec<string | number>).matchAll?.[0] ===
      "string" ||
    typeof (item as complexMatchSpec<string | number>).matchNone?.[0] ===
      "string"
  );
};

export const itemIsComplexMatchSpecDealerCodeSpec = (
  item:
    | { before: string; after: string }
    | complexMatchSpec<string | number>
    | dealerCodeSpecComplexMatchSpec
): item is dealerCodeSpecComplexMatchSpec => {
  return (
    (item as dealerCodeSpecComplexMatchSpec).matchAll?.[0]?.codes !== undefined
  );
};

export interface PagesClientSearchSearchPillsProps {
  items?:
    | string[]
    | { before: string; after: string }
    | complexMatchSpec<string | number>
    | dealerCodeSpecComplexMatchSpec;
  label: string;
  mappingKey: keyof dealerSearchIncoming;
  onClick: (
    value: string | number,
    mappingKey: keyof dealerSearchIncoming
  ) => void;
}
